export const CHAT_OPENING_DELAY = 1000; //ms, later can be configurable from admin panel
export const CHECK_AVAILABILITY_TIMEOUT = 60000; //ms, later can be configurable from admin panel
export const CHECK_ONLINE_STATUS_TIMEOUT = 3000; // ms

export const DEFAULT_TYPING_DURATION = 2000;

export const CHAT_CLOSE_EVENT = 'rxChatClose';
export const CHAT_AUTO_OPEN_EVENT = 'rxChatAutoOpen';
export const CHAT_READY_EVENT = 'rxDefineChatReady';

const intakeLandingExp = /\/landing\//gm;
const href = window.location.href;

export const isIntake = !!document.querySelector('head[data-ostro-intake]');
export const isIntakeLanding = isIntake && intakeLandingExp.test(href);

export const enum ChatVersion {
  v1_0 = 'v1',
  v2_0 = 'v2',
  v2_1 = 'v2.1',
  v3_0 = 'v3.0',
  v4_0 = 'v4.0',
  v4_1 = 'v4.1',
}

export const enum TopicSource {
  LandingPage = 'LandingPage',
  Suggested = 'Suggested',
  SearchResult = 'Search result',
  CategoryPage = 'CategoryPage',
  Pill = 'Pill',
  ConvAiQuery = 'ConvAiQuery',
  VAOptionClick = 'VAOptionClick',
}

export const enum TopicType {
  Content = 'Content',
  ExternalLink = 'ExternalLink',
  ExternalThumbnailLink = 'ExternalThumbnailLink',
  Downloadable = 'Downloadable',
}

export const ActiveScreen = {
  '/tailor': 'LandingPage',
  '/tailor/search': 'SearchPage',
  '/tailor/article': 'ArticlePage',
  '/tailor/article/:id': 'ArticlePage',
  '/tailor/category/:category': 'CategoryPage',
  '/tailor/info/isi': 'ISIPage',
  '/tailor/info/privacy': 'PrivacyPage',
  '/tailor/info/terms': 'TermsPage',
  '/virtual-assistant': 'VirtualAssistant',
  '/virtual-assistant/:action': 'VirtualAssistant',
  '/tailor/interstitial': 'TailorInterstitial',
  '/tailor/contact-form': 'ContactForm',
  // [UIState.CHAT_BOT]: 'virtual_assistant',
  // [UIState.TERMS_OF_USE]: 'terms_of_use',
  // [UIState.TERMS_OF_USE_HC]: 'terms_of_use',
  // [UIState.PRIVACY_POLICY]: 'privacy_policy',
  // [UIState.PRIVACY_POLICY_HC]: 'privacy_policy',
  // [UIState.NAVIGATOR_DEFINITION]: 'navigator_definition',
  // [UIState.CUSTOM_CONTENT]: 'other',
  '/live-chat': 'LiveChat',
};
